import { useEffect, useMemo, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { PLPPages, PLPReactQueryKeys, PLPSlug } from '../types'

interface Params {
    page: PLPPages
    slug?: PLPSlug
}

export default function useBasicMetasInitialLoading({ page, slug }: Params) {
    const [isLoading, setIsLoading] = useState(true)
    const [shouldSendRequest, setShouldSendRequest] = useState(true)

    const queryClient = useQueryClient()
    const queryKey = useMemo(() => [PLPReactQueryKeys.BasicMeta, { page, slug }], [page, slug])

    useEffect(() => {
        const init = async () => {
            if (!shouldSendRequest) return

            if (page !== PLPPages.Search) {
                await queryClient.refetchQueries({ queryKey })
            }

            setShouldSendRequest(false)

            setIsLoading(false)
        }

        init()
    }, [queryClient, queryKey, shouldSendRequest, page])

    return isLoading
}
